/* V1 singleton */
(() => {
if (window.snDealsPageReady) return;
window.snDealsPageReady = true;
if (!customElements.get('sn-deals-carousel')) {
  customElements.define('sn-deals-carousel', class SnDealsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.events = new AbortController();
      this.rail = this.querySelector('[data-deals-rail]');
      this.previousButton = this.querySelector('[data-deals-previous]');
      this.nextButton = this.querySelector('[data-deals-next]');
      this.pagination = this.querySelector('[data-deals-pagination]');
      if (!this.rail) return;

      this.previousButton?.addEventListener('click', () => this.move(-1), { signal: this.events.signal });
      this.nextButton?.addEventListener('click', () => this.move(1), { signal: this.events.signal });
      this.rail.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal: this.events.signal });
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.rail);
      this.measure();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.events?.abort(); cancelAnimationFrame(this.updateFrame);
      delete this.dataset.ready;
    }

    getStep() {
      const firstCard = this.rail?.firstElementChild;
      if (!firstCard) return this.rail?.clientWidth || 0;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    measure() {
      this.maximum = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
      this.step = Math.max(1, this.getStep());
      this.update();
    }

    move(direction) {
      this.rail.scrollBy({ left: direction * this.step, behavior: 'smooth' });
    }

    queueUpdate() {
      cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.update());
    }

    update() {
      const maximum = this.maximum;
      const step = this.step;
      const pageCount = Math.max(1, Math.ceil(maximum / step) + 1);
      const currentPage = Math.min(pageCount - 1, Math.max(0, Math.round(this.rail.scrollLeft / step)));
      if (this.previousButton) this.previousButton.disabled = this.rail.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = this.rail.scrollLeft >= maximum - 2;
      if (this.pagination && this.pageCount !== pageCount) {
        this.pageCount = pageCount;
        this.pagination.innerHTML = '';
        for (let index = 0; index < Math.min(pageCount, 8); index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sn-deals-carousel__dot';
          const slideLabel = (window.snStrings?.slideStatus || '')
            .replace('[index]', String(index + 1))
            .replace('[length]', String(pageCount));
          dot.setAttribute('aria-label', slideLabel);
          if (index === Math.min(currentPage, 7)) dot.setAttribute('aria-current', 'true');
          dot.addEventListener('click', () => this.rail.scrollTo({ left: index * this.step, behavior: 'smooth' }));
          this.pagination.append(dot);
        }
      }
      this.pagination?.querySelectorAll('button').forEach((dot, index) => {
        if (index === Math.min(currentPage, 7)) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  });
}

if (!customElements.get('sn-deals-countdown')) {
  customElements.define('sn-deals-countdown', class SnDealsCountdown extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.target = new Date(this.dataset.endAt || '');
      if (Number.isNaN(this.target.getTime())) {
        this.hidden = true;
        return;
      }
      this.render();
      this.timer = window.setInterval(() => this.render(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      delete this.dataset.ready;
    }

    render() {
      if (document.hidden) return;
      const remaining = Math.max(0, this.target.getTime() - Date.now());
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      this.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      this.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      this.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
      if (remaining === 0) {
        window.clearInterval(this.timer);
        this.classList.add('is-expired');
        const label = this.querySelector('[data-countdown-label]');
        if (label) label.textContent = this.dataset.expiredText || label.textContent;
      }
    }
  });
}

document.addEventListener('click', async event => {
  const button = event.target.closest('[data-deals-copy]');
  if (!button) return;
  const code = button.dataset.dealsCopy || '';
  const originalLabel = button.dataset.originalLabel || button.textContent.trim();
  button.dataset.originalLabel = originalLabel;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(code);
    } else {
      const input = document.createElement('textarea');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.append(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    button.textContent = button.dataset.copiedLabel || window.snStrings?.copied || originalLabel;
    button.classList.add('is-copied');
    window.setTimeout(() => {
      button.textContent = originalLabel;
      button.classList.remove('is-copied');
    }, 1800);
  } catch (error) {
    button.textContent = code;
  }
});

})();
